module.exports = __webpack_public_path__ + "img/qilin-f-stage2-blink.a3551591.png";